import React, { useEffect, useState } from 'react';

const apiBase = (import.meta.env.VITE_API_URL || 'http://localhost:8000').replace(/\/$/, '');

export const GmailOAuthCallback: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const error = params.get('error');

    if (error) {
      setStatus('error');
      setMessage(`OAuth error: ${error}`);
      return;
    }

    if (!code) {
      setStatus('error');
      setMessage('No authorization code received from Google.');
      return;
    }

    const redirectUri = `${window.location.origin}/oauth/gmail/callback`;

    fetch(`${apiBase}/api/v1/integrations/gmail/oauth/exchange`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, redirect_uri: redirectUri }),
    })
      .then(async res => {
        const data = await res.json();
        if (res.ok && data.success) {
          setStatus('success');
          setMessage('Gmail connected successfully! You can close this tab.');
          setTimeout(() => window.close(), 2500);
        } else {
          setStatus('error');
          setMessage(data.detail || 'Authorization failed. Please try again.');
        }
      })
      .catch(err => {
        setStatus('error');
        setMessage(`Connection error: ${err.message}`);
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-10 max-w-md w-full text-center">
        <div className="text-4xl mb-4">📧</div>
        {status === 'loading' && (
          <>
            <div className="w-6 h-6 border-2 border-fuchsia-300 border-t-fuchsia-600 rounded-full animate-spin mx-auto mb-4" />
            <p className="text-gray-600">Completing Gmail authorization…</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="text-green-500 text-2xl mb-2">✓</div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">Gmail Connected</h2>
            <p className="text-sm text-gray-500">{message}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="text-red-500 text-2xl mb-2">✗</div>
            <h2 className="text-lg font-semibold text-gray-900 mb-1">Authorization Failed</h2>
            <p className="text-sm text-gray-500">{message}</p>
            <button
              onClick={() => window.close()}
              className="mt-4 px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
            >
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
};
